import noImage from '../../assets/no_image.jpeg';

function ItemImageDisplay({ imageList }) {
  const images = imageList ?? [];

  return (
    <>
      <div className="container mx-auto">
        <div className="h-72 w-full @sm:p-4 bg-white flex items-center justify-center border-[1px] border-gray-200 rounded-xl">
          <img
            key={images[0]?.image_url ?? 'main'}
            src={images[0]?.image_url || noImage}
            alt="image_1"
            className="h-full w-auto aspect-auto object-contain bg-white"
          />
        </div>
        <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-4">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="w-full h-auto p-2 rounded bg-white shadow-md">
              <img
                key={images[i]?.image_url ?? `thumb-${i}`}
                src={images[i]?.image_url || noImage}
                alt={`image_${i + 1}`}
                className="h-full w-auto object-contain"
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default ItemImageDisplay;
